import axios from "axios";
import Swal from "sweetalert2";
import { get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import IncidentCommentItem from "@/components/IncidentCommentItem/IncidentCommentItem.vue";
import * as home_profile_helper from "@/views/Feed/feed_helper.js";
const GOOGLE_MAP_API_KEY = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
import { basic_incident_report_methods } from "./basic_incident_report_api";
import { incident_comment_methods } from "./incident_comment_helper";
import { get_active_organization_id } from "@/utils/organization_profile";
import { incident_progress_methods } from "@/utils/incident_progress_helper";
import {
  add_uploaded_icon_option,
  handle_icon_upload,
  is_icon_option_selected,
  select_icon_option,
} from "@/views/manage_incident/manage_incident_helper";
import manage_incident_type_api from "@/views/manage_incident_type/manage_incident_type_api";
export default {
  name: "IncidentLogger",
  components: {
    HomeNavBar,
    IncidentCommentItem,
  },
  data() {
    return ({
      base_url: process.env.VUE_APP_BACKEND_API_URL,
      entity_types: [],
      selected_type_id: null,
      selected_form_id: null,
      form_schema: [],
      form_data: {},
      form_errors: {},
      is_loading: false,
      is_submitting: false,
      feedback: { message: "", color: "" },
      logged_entries: [],
      incident_pagination: {},
      incident_page_size: 10,
      incident_has_more: true,
      incident_loading_more: false,
      incident_scroll_timeout: null,
      search_query: "",
      filter_status: "All",
      filter_location: "All",
      filter_type: "All",
      statuses: [],
      selected: null,
      loading: false,
      show_map_view: false,
      incident_map: null,
      incident_markers: [],
      incident_marker_load_id: 0,
      incident_map_marker: null,
      filter_map: null,
      filter_map_marker: null,
      map_geocoder: null,
      filter_dropdown_open: false,
      google_maps_load_promise: null,
      location_geocode_cache: {},
      filter_map_default_center: { lat: 6.5244, lng: 3.3792 },
      project_id : process.env.VUE_APP_PROJECT_ID,
      user_details: get_user_details() || {},
      active_profile: null,
      activity_open: {},
      comment_panel_open: {},
      comments_expanded: {},
      comment_replies_expanded: {},
      share_menu_open: {},
      comment_drafts: {},
      comment_reply_targets: {},
      editing_comment_id: null,
      editing_incident_report_id: null,
      incident_report_files_to_delete: [],
      editing_comment_drafts: {},
      comment_action_loading: {},
      isDragging: false,
      is_prefilling_basic_incident: false,
      selected_incident_image: null,
      selected_incident_images: [],
      selected_incident_image_index: 0,
      incident_active: 'basic'
      ,
      show_new_type_form: false,
      saving_incident_type: false,
      new_type_error: "",
      type_form: {
        name: "",
        icon: "bi-exclamation-triangle-fill",
        color: "#0d6efd",
        file: null,
      },
      available_icons: [
        { name: "Water", value: "bi-droplet-fill" },
        { name: "Electricity", value: "bi-lightning-charge-fill" },
        { name: "Housing", value: "bi-house-door-fill" },
        { name: "Roads", value: "bi-sign-stop-fill" },
        { name: "Waste", value: "bi-trash3-fill" },
        { name: "Sewerage", value: "bi-moisture" },
        { name: "Lighting", value: "bi-lightbulb-fill" },
        { name: "Safety", value: "bi-shield-exclamation" },
        { name: "Fire", value: "bi-fire" },
        { name: "Parks", value: "bi-tree-fill" },
        { name: "Noise", value: "bi-volume-up-fill" },
        { name: "Construction", value: "bi-cone-striped" },
        { name: "Transport", value: "bi-bus-front-fill" },
        { name: "Health", value: "bi-heart-pulse-fill" },
        { name: "Animal", value: "bi-bug-fill" },
        { name: "General", value: "bi-exclamation-triangle-fill" },
      ],
    });
  },
  watch: {
    selected_type_id(newVal) {
      if (this.is_prefilling_basic_incident) return;
      if (newVal) {
        if(this.incident_active === 'basic'){
          this.basic_form_scheme()
        }
        else{
          this.fetch_form_by_entity_type();
        }
      } else {
        this.form_schema = [];
        this.form_data = {};
      }
    },
    show_map_view(newValue) {
      if (!newValue && this.incident_map) {
        this.incident_marker_load_id += 1;
        this.incident_markers.forEach(marker => marker.setMap(null));
        this.incident_markers = [];
        this.incident_map = null;
      }
    },
    filter_status() {
      this.reload_map();
    },
    filter_location() {
      this.reload_map();
    },
    filter_type() {
      this.reload_map();
    },
    search_query() {
      this.reload_map();
    },
    logged_entries: {
      handler() {
        this.reload_map();
      },
      deep: true
    }
  },
  computed: {
    incident_comment_controller() {
      return this;
    },
    profileImage() {
      const files =
        this.active_profile?.profile_files ||
        this.active_profile?.user?.profile?.profile_files ||
        this.active_profile?.company?.base_profile?.profile_files ||
        [];

      const profilePicture = files.find(file => file.profile_file_type === "profile_picture") || files[0];

      return profilePicture?.file?.file_url || profilePicture?.file?.url || null;
    },
    composer_display_name() {
      return (
        this.active_profile?.profile_name ||
        this.active_profile?.company?.company_name ||
        this.active_profile?.user?.first_name ||
        this.user_details?.first_name ||
        "there"
      );
    },
    incident_profile_name() {
      const user_name = [
        this.user_details?.first_name,
        this.user_details?.last_name,
      ]
        .filter(Boolean)
        .join(" ");

      return (
        this.active_profile?.profile_name ||
        this.active_profile?.company?.company_name ||
        user_name ||
        "Profile"
      );
    },
    incident_profile_handle() {
      const raw_handle = this.incident_profile_name || this.composer_display_name || "profile";
      return `@${String(raw_handle).toLowerCase().replace(/[^a-z0-9]+/g, '').slice(0, 18) || 'profile'}`;
    },
    incident_profile_initials() {
      const name_parts = String(this.incident_profile_name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      if (!name_parts.length) return 'U';
      const initials = name_parts.length === 1
        ? name_parts[0].slice(0, 2)
        : `${name_parts[0][0]}${name_parts[name_parts.length - 1][0]}`;
      return initials.toUpperCase();
    },
    incident_user_role() {
      return String(
        this.user_details?.user_role ||
        ''
      ).trim().toLowerCase();
    },
    can_assign_incident_reports() {
      return [
        'admin',
        'organization admin',
      ].includes(this.incident_user_role);
    },
    assign_incident_reports_href() {
      return [
        'organization admin',
      ].includes(this.incident_user_role)
        ? '/organisation_manage_incidents'
        : '/manage_incidents';
    },
    incident_left_nav_items() {
      return [
        {
          show: true,
          label: 'Incident Reports',
          icon: 'bi-shield-exclamation',
          active: !this.show_map_view,
          event: 'show-reports',
        },
        {
          show: true,
          label: 'Report Incident',
          icon: 'bi-plus-circle-fill',
          event: 'create-incident',
        },
        {
          show: this.can_assign_incident_reports,
          label: 'Assign Incident Reports',
          icon: 'bi-person-check-fill',
          href: this.assign_incident_reports_href,
        },
        {
          show: true,
          label: 'Map View',
          icon: 'bi-geo-alt-fill',
          event: 'toggle-map',
          active: this.show_map_view,
        },
        {
          show: Boolean(this.user_details?.user_id),
          label: 'Settings',
          icon: 'bi-gear-fill',
          href: home_profile_helper.get_profile_url({ id: this.user_details.user_id }),
        },
      ].filter((item) => item.show);
    },
    active_filter_count() {
      let count = 0;

      if (this.search_query) count++;
      if (this.filter_status !== 'All') count++;
      if (this.filter_type !== 'All') count++;
      if (this.filter_location !== 'All') count++;

      return count;
    },
    workflow_steps() {
      return this.workflow_display_steps.map(step => ({ status: Reflect.get(step, 'label') }));
    },

    workflow_display_steps() {
      return [
        { key: 'pending', label: 'Under Review', icon: 'bi bi-hourglass-split' },
        { key: 'assigned', label: 'Assigned', icon: 'bi bi-person-fill' },
        { key: 'in_progress', label: 'In Progress', icon: 'bi bi-wrench-adjustable-circle' },
        { key: 'resolved', label: 'Resolved', icon: 'bi bi-stars' }
      ];
    },
    unique_locations() {
      const locations = this.logged_entries
        .map(r => r.location)
        .filter(l => l && l.trim() !== "");
      return ['All', ...new Set(locations)];
    },
    filtered_entries() {
      return this.logged_entries.filter(r => {
        const matchesStatus = this.filter_status === 'All' || this.get_current_status_label(r) === this.filter_status;
        const matchesLocation = this.filter_location === 'All' || r.location === this.filter_location;
        const category_name = this.get_incident_category_name(r);
        const matchesType = this.matches_incident_type_filter(r);

        const searchLower = this.search_query.toLowerCase();
        const matchesSearch = !this.search_query ||
          `INC-${r.id}`.toLowerCase().includes(searchLower) ||
          r.description?.toLowerCase().includes(searchLower) ||
          r.location?.toLowerCase().includes(searchLower) ||
          category_name.toLowerCase().includes(searchLower);

        return matchesStatus && matchesLocation && matchesType && matchesSearch;
      });
    },
    incident_category_counts() {
      const counts = new Map();

      this.category_count_entries.forEach(entry => {
        const name = this.get_incident_category_name(entry);
        const current = counts.get(name) || {
          name,
          count: 0,
          color: this.get_incident_category_color(name),
        };

        current.count += 1;
        counts.set(name, current);
      });

      return Array.from(counts.values()).sort((a, b) => a.name.localeCompare(b.name));
    },
    category_count_entries() {
      return this.logged_entries.filter(r => {
        const matchesStatus = this.filter_status === 'All' || this.get_current_status_label(r) === this.filter_status;
        const matchesLocation = this.filter_location === 'All' || r.location === this.filter_location;
        const category_name = this.get_incident_category_name(r);

        const searchLower = this.search_query.toLowerCase();
        const matchesSearch = !this.search_query ||
          `INC-${r.id}`.toLowerCase().includes(searchLower) ||
          r.description?.toLowerCase().includes(searchLower) ||
          r.location?.toLowerCase().includes(searchLower) ||
          category_name.toLowerCase().includes(searchLower);

        return matchesStatus && matchesLocation && matchesSearch;
      });
    }
  },

  mounted() {
    this.load_active_profile();
    if(this.incident_active === 'basic'){
      if(get_active_organization_id()){
        this.get_incident_types_by_scope()
      }
      else{
        this.get_incident_types();
      }
      this.get_incident_reports();
    }
    else{
      this.fetch_entity_types();
      this.view_form_statuses();
      this.fetch_pending_entities();
    }
    this.incident_modal_element = document.getElementById("incidentModal");
    this.incident_modal_element?.addEventListener("shown.bs.modal", this.handle_incident_modal_shown);
    this.incident_modal_element?.addEventListener("hidden.bs.modal", this.handle_incident_modal_hidden);
    if (this.show_map_view) {
      this.load_google_maps_api()
        .then(() => this.$nextTick(() => this.init_incident_map()))
        .catch(err => {
          console.error("Unable to load Google Maps", err);
        });
    }
  },
  beforeUnmount() {
    if (this.incident_scroll_timeout) {
      clearTimeout(this.incident_scroll_timeout);
    }
    this.incident_modal_element?.removeEventListener("shown.bs.modal", this.handle_incident_modal_shown);
    this.incident_modal_element?.removeEventListener("hidden.bs.modal", this.handle_incident_modal_hidden);
  },
  methods: {
    ...basic_incident_report_methods,
    ...incident_comment_methods,
    ...incident_progress_methods,
    select_icon_option,
    is_icon_option_selected,
    add_uploaded_icon_option,
    handle_icon_upload,
    build_request_headers: manage_incident_type_api.build_request_headers,
    create_incident_type: manage_incident_type_api.create_incident_type,
    toggle_new_type_form() {
      this.show_new_type_form = !this.show_new_type_form;
      this.new_type_error = "";
      if (this.show_new_type_form) {
        this.$nextTick(() => {
          const selector = window.innerWidth <= 768
            ? ".incident-new-type-mobile-form"
            : ".incident-new-type-form";
          document.querySelector(selector)?.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        });
      }
    },
    reset_new_type_form() {
      this.type_form = {
        name: "",
        icon: "bi-exclamation-triangle-fill",
        color: "#0d6efd",
        file: null,
      };
      this.new_type_error = "";
      this.show_new_type_form = false;
    },
    create_inline_incident_type() {
      const name = String(this.type_form.name || "").trim();
      if (!name) {
        this.new_type_error = "Type name is required.";
        return;
      }
      if (!/^#[0-9a-f]{6}$/i.test(this.type_form.color)) {
        this.new_type_error = "Choose a valid six-digit colour.";
        return;
      }
      if (this.entity_types.some(
        (type) => String(type.entity_type_name || "").trim().toLowerCase() === name.toLowerCase()
      )) {
        this.new_type_error = "An incident type with this name already exists.";
        return;
      }

      this.new_type_error = "";
      this.create_incident_type();
    },
    handle_create_incident_type_success(response) {
      const created_type = {
        ...response.data,
        entity_type_name: response.data.entity_type_name || this.type_form.name.trim(),
      };
      this.entity_types = this.sort_entity_types([
        ...this.entity_types,
        created_type,
      ]);
      this.selected_type_id = created_type.id;
      this.reset_new_type_form();
      Swal.fire({
        icon: "success",
        title: "Incident type created",
        text: response.message || "Incident type created successfully.",
        timer: 1800,
        showConfirmButton: false,
        position: "bottom-end",
        toast: true,
      });
    },
    handle_create_incident_type_error(xhr) {
      this.new_type_error = xhr?.responseJSON?.message || "Unable to create incident type.";
    },
    get_incident_type_file_url(type) {
      const file = type?.file;
      if (typeof file === "string") return file;
      return file?.file_url || file?.url || "";
    },
    read_incident_value(source, path, fallback = null) {
      return path.reduce(
        (value, key) => Reflect.get(Object(value), key),
        source,
      ) ?? fallback;
    },
    handle_incident_left_nav_action(item) {
      if (item.event === 'show-reports') {
        this.show_reports_view();
      }

      if (item.event === 'create-incident') {
        this.open_incident_modal();
      }

      if (item.event === 'toggle-map') {
        this.toggle_map();
      }
    },
    go_to_incident_assignment(report) {
      if (!this.can_assign_incident_reports) return;
      this.$router.push({
        path: this.assign_incident_reports_href,
        query: { incident_report_id: report?.id },
      });
    },
    is_incident_assigned(report) {
      if (Array.isArray(report?.assigned_users)) {
        return report.assigned_users.some(assignment => assignment?.user);
      }
      return false;
    },
    show_reports_view() {
      this.show_map_view = false;
    },
    open_incident_modal() {
      const modal_element = document.getElementById("incidentModal");
      if (!modal_element) return;

      if (window.bootstrap?.Modal) {
        window.bootstrap.Modal.getOrCreateInstance(modal_element).show();
      }
    },
    parse_stored_profile(key) {

      return JSON.parse(localStorage.getItem(key) || "null");
    },
    load_active_profile() {
      const storageKeys = ["activeProfile", "active_profile", "base_profile", "activeBaseProfile"];

      for (const key of storageKeys) {
        const storedProfile = this.parse_stored_profile(key);

        if (storedProfile) {
          this.active_profile = storedProfile;
          return;
        }
      }
    },
    toggle_activity(id) {
      const activityOpen = this.activity_open || {};
      const current = !!Reflect.get(activityOpen, id);
      const nextActivityOpen = { ...activityOpen };
      Reflect.set(nextActivityOpen, id, !current);
      this.activity_open = nextActivityOpen;
    },
    is_activity_open(id) {
      return !!Reflect.get(this.activity_open || {}, id);
    },
    toggle_share_menu(id) {
      this.share_menu_open = {
        ...(this.share_menu_open || {}),
        [id]: !this.is_share_menu_open(id)
      };
    },
    is_share_menu_open(id) {
      return !!Reflect.get(this.share_menu_open || {}, id);
    },
    close_share_menu(id) {
      this.share_menu_open = {
        ...(this.share_menu_open || {}),
        [id]: false
      };
    },
    get_reporter_name(r) {
      const user = r.user || r.created_by || r.reporter || r.applicant || r.submitted_by;
      if (!user) return 'Citizen';

      if (typeof user === 'string') return user;

      const fullName = [
        user.first_name,
        user.last_name
      ].filter(Boolean).join(' ').trim();

      return fullName || user.name || user.username || 'Citizen';
    },
    get_reporter_initials(r) {
      const name = this.get_reporter_name(r);
      const initials = name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part.charAt(0).toUpperCase())
        .join('');

      return initials || 'C';
    },
    get_attachment_count(r) {
      return this.get_incident_attachments(r).length;
    },
    get_incident_attachments(r) {
      const attachments = [
        ...(Array.isArray(r.incident_report_files) ? r.incident_report_files : [])
      ];
      const seen_attachments = new Set();

      return attachments.reduce((unique_attachments, attachment) => {
        const file = Reflect.get(Object(attachment), "file") || attachment;
        const normalized_attachment = this.normalize_incident_attachment(attachment);
        const attachment_id = Reflect.get(Object(attachment), "id")
          || Reflect.get(Object(file), "id");
        const unique_key = attachment_id
          ? `id:${attachment_id}`
          : (normalized_attachment.url ? `url:${normalized_attachment.url}` : null);

        if (unique_key && seen_attachments.has(unique_key)) return unique_attachments;
        if (unique_key) seen_attachments.add(unique_key);
        unique_attachments.push(normalized_attachment);
        return unique_attachments;
      }, []);
    },
    get_incident_image_attachments(r) {
      return this.get_incident_attachments(r)
        .filter((attachment) => attachment.is_image && attachment.url);
    },
    get_visible_incident_images(r) {
      return this.get_incident_image_attachments(r).slice(0, 4);
    },
    get_incident_extra_image_count(r) {
      return Math.max(this.get_incident_image_attachments(r).length - 4, 0);
    },
    get_incident_file_attachments(r) {
      return this.get_incident_attachments(r)
        .filter((attachment) => !attachment.is_image || !attachment.url);
    },
    normalize_incident_attachment(attachment = {}) {
      const file = Reflect.get(attachment, 'file') || attachment;
      const name = this.get_incident_attachment_name(file, attachment);
      const url = this.get_incident_attachment_url(file, attachment);

      return ({
        name,
        url,
        icon: this.get_incident_attachment_icon(name),
        is_image: this.is_incident_image_attachment(name, file, attachment)
      });
    },
    get_incident_attachment_name(file = {}, attachment = {}) {
      return Reflect.get(file, 'name')
        || Reflect.get(attachment, 'name')
        || 'Attachment';
    },
    get_incident_attachment_url(file = {}, attachment = {}) {
      const url = Reflect.get(file, 'file_url')
        || Reflect.get(attachment, 'file_url')
        || '';

      return this.normalize_incident_attachment_url(url);
    },
    normalize_incident_attachment_url(url) {
      if (!url) return '';
      if (/^https?:\/\//i.test(url)) return url;
      return `${this.base_url}${url.startsWith('/') ? '' : '/'}${url}`;
    },
    get_incident_attachment_icon(name = '') {
      const extension = String(name).split('.').pop().toLowerCase();
      if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(extension)) return 'bi-file-earmark-image';
      if (['mp4', 'mov', 'webm'].includes(extension)) return 'bi-file-earmark-play';
      if (['mp3', 'wav', 'm4a'].includes(extension)) return 'bi-file-earmark-music';
      if (extension === 'pdf') return 'bi-file-earmark-pdf';
      return 'bi-paperclip';
    },
    is_incident_image_attachment(name = '', file = {}, attachment = {}) {
      const type = Reflect.get(file, 'type') || Reflect.get(attachment, 'type') || '';
      const extension = String(name).split('.').pop().toLowerCase();
      return String(type).startsWith('image/')
        || ['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(extension);
    },
    open_incident_image_modal(attachment, report = null) {
      if (!attachment?.url) return;

      const images = report ? this.get_incident_image_attachments(report) : [attachment];
      const selected_index = images.findIndex((image) => image.url === attachment.url);
      this.selected_incident_images = images.length ? images : [attachment];
      this.selected_incident_image_index = Math.max(selected_index, 0);
      this.selected_incident_image = attachment;
      this.$nextTick(() => {
        const modal_element = document.getElementById("incidentImagePreviewModal");
        if (!modal_element) return;

        window.bootstrap.Modal.getOrCreateInstance(modal_element).show();
      });
    },
    close_incident_image_modal() {
      const modal_element = document.getElementById("incidentImagePreviewModal");
      if (!modal_element) return;

      window.bootstrap.Modal.getOrCreateInstance(modal_element).hide();
    },
    show_previous_incident_image() {
      this.set_selected_incident_image_index(this.selected_incident_image_index - 1);
    },
    show_next_incident_image() {
      this.set_selected_incident_image_index(this.selected_incident_image_index + 1);
    },
    set_selected_incident_image_index(index) {
      const images = this.selected_incident_images || [];
      if (!images.length) return;

      const next_index = (index + images.length) % images.length;
      this.selected_incident_image_index = next_index;
      this.selected_incident_image = Reflect.get(images, next_index);
    },
    is_incident_liked(report) {
      return Boolean(report?.is_liked ?? report?.is_likes);
    },
    get_incident_like_count(r) {
      return Number(r.total_likes ?? r.like_count ?? r.likes_count ?? r.likes?.length ?? 0) || 0;
    },
    async toggle_incident_like(r) {
      const wasLiked = this.is_incident_liked(r);
      r.is_liked = !wasLiked;

      r.total_likes = Math.max(this.get_incident_like_count(r) + (wasLiked ? -1 : 1), 0);

      try {
        const { data } = await axios.post(
          `${this.base_url}/report_incident_management/like_incident_report/`,
          this.get_incident_reference_payload(r),
          this.axios_config()
        );

        this.apply_incident_interaction_summary(r, data);
      } catch (err) {
        r.is_liked = wasLiked;
        r.total_likes = Math.max(this.get_incident_like_count(r) + (wasLiked ? 1 : -1), 0);
        console.error("Failed to like incident report", err);
      }
    },
    get_incident_comments(r) {
      const backendComments = Array.isArray(r.comments) ? r.comments : [];
      return backendComments;
    },
    get_incident_comment_count(r) {
      return Number(r.total_comments ?? r.comment_count ?? r.comments_count ?? r.comments?.length ?? 0) || 0;
    },
    get_comment_author(comment) {
      const user = comment.user || comment.created_by || comment.author;
      if (!user) return 'You';
      if (typeof user === 'string') return user;

      const name = [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
      return name || user.name || user.username || 'Citizen';
    },
    get_comment_initials(comment) {
      const name = this.get_comment_author(comment);
      return name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part.charAt(0).toUpperCase())
        .join('') || 'C';
    },
    get_comment_profile_image(comment) {
      return comment?.user?.profile_picture || null;
    },
    get_comment_text(comment) {
      return comment.comment_text || comment.comment || comment.text || '';
    },
    get_comment_timestamp(comment) {
      const value =  comment.created_at;
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);

      const time = new Intl.DateTimeFormat('en-GB', {
        hour: '2-digit', minute: '2-digit', hour12: false
      }).format(date);
      const calendarDate = new Intl.DateTimeFormat('en-GB', {
        weekday: 'short', day: '2-digit', month: 'long', year: 'numeric'
      }).format(date).replace(',', '');
      return `${time} ${calendarDate}`;
    },
    get_current_user_id() {
      const user = get_user_details() || this.user_details || {};
      return user.id || user.user_id || localStorage.getItem('user_id') || '';
    },
    can_manage_comment(comment) {
      const current_user_id = String(this.get_current_user_id() || '');
      const comment_user_id = String(comment?.user?.id || comment?.created_by?.id || comment?.author?.id || '');
      return !!current_user_id && !!comment_user_id && current_user_id === comment_user_id;
    },
    is_comment_editing(comment) {
      return this.editing_comment_id === comment.id;
    },
    start_edit_incident_comment(comment) {
      this.editing_comment_id = comment.id;
      this.editing_comment_drafts = {
        ...(this.editing_comment_drafts || {}),
        [comment.id]: this.get_comment_text(comment)
      };
    },
    cancel_edit_incident_comment() {
      this.editing_comment_id = null;
    },
    is_comment_action_loading(comment_id) {
      return !!Reflect.get(this.comment_action_loading || {}, comment_id);
    },
    set_comment_action_loading(comment_id, is_loading) {
      this.comment_action_loading = {
        ...(this.comment_action_loading || {}),
        [comment_id]: is_loading
      };
    },
    get_incident_comment_error(error, fallback) {
      const data = error?.response?.data;
      if (typeof data === 'string') return data;
      if (data?.detail || data?.error || data?.message) {
        return data.detail || data.error || data.message;
      }
      const field_error = data && Object.values(data).flat().find(Boolean);
      return field_error || fallback;
    },
    replace_incident_comment(report, updated_comment) {
      const comments = this.get_incident_comments(report);
      report.comments = comments.map(comment => (
        comment.id === updated_comment.id ? updated_comment : comment
      ));
    },
    remove_incident_comment(report, comment_id) {
      report.comments = this.get_incident_comments(report).filter(comment => comment.id !== comment_id);
      report.total_comments = report.comments.length;
      report.comment_count = report.total_comments;
    },
    async submit_edit_incident_comment(r, comment) {
      const draft = (Reflect.get(this.editing_comment_drafts || {}, comment.id) || '').trim();
      if (!draft) return;

      this.set_comment_action_loading(comment.id, true);

      try {
        const { data } = await axios.patch(
          `${this.base_url}/report_incident_management/edit_incident_report_comment/`,
          {
            comment_id: comment.id,
            comment: draft
          },
          this.axios_config()
        );

        if (data?.comment) {
          this.replace_incident_comment(r, data.comment);
        }

        if (data?.summary) {
          this.apply_incident_interaction_summary(r, data.summary);
        }

        this.editing_comment_id = null;
      } catch (err) {
        console.error("Failed to edit incident comment", err);
        Swal.fire({
          icon: "error",
          title: "Comment not updated",
          text: this.get_incident_comment_error(err, "Unable to update this comment."),
        });
      } finally {
        this.set_comment_action_loading(comment.id, false);
      }
    },
    async delete_incident_comment(r, comment) {
      if (!comment?.id) return;

      const confirmation = await Swal.fire({
        icon: "warning",
        title: "Delete comment?",
        text: "This action cannot be undone.",
        showCancelButton: true,
        confirmButtonText: "Delete",
        confirmButtonColor: "#dc3545",
      });
      if (!confirmation.isConfirmed) return;

      this.set_comment_action_loading(comment.id, true);

      try {
        const { data } = await axios.delete(
          `${this.base_url}/report_incident_management/delete_incident_report_comment/`,
          {
            ...this.axios_config(),
            data: {
              comment_id: comment.id
            }
          }
        );

        this.remove_incident_comment(r, comment.id);
        this.apply_incident_interaction_summary(r, data);
      } catch (err) {
        console.error("Failed to delete incident comment", err);
        Swal.fire({
          icon: "error",
          title: "Comment not deleted",
          text: this.get_incident_comment_error(err, "Unable to delete this comment."),
        });
      } finally {
        this.set_comment_action_loading(comment.id, false);
      }
    },
    async submit_incident_comment(r) {
      const draft = (Reflect.get(this.comment_drafts || {}, r.id) || '').trim();
      if (!draft) return;
      const parent_comment_id = Reflect.get(this.comment_reply_targets || {}, r.id) || null;

      this.comment_drafts = {
        ...(this.comment_drafts || {}),
        [r.id]: ''
      };

      try {
        const { data } = await axios.post(
          `${this.base_url}/report_incident_management/comment_incident_report/`,
          {
            ...this.get_incident_reference_payload(r),
            comment: draft,
            parent_comment_id,
          },
          this.axios_config()
        );

        if (data?.summary) {
          this.apply_incident_interaction_summary(r, data.summary);
        }

        if (!data?.summary && data?.comment && !this.get_incident_comments(r).some(comment => comment.id === data.comment.id)) {
          r.comments = [data.comment, ...this.get_incident_comments(r)];
          r.total_comments = this.get_incident_comment_count(r) || r.comments.length;
        }
        this.comment_reply_targets = {
          ...(this.comment_reply_targets || {}),
          [r.id]: null,
        };
      } catch (err) {
        this.comment_drafts = {
          ...(this.comment_drafts || {}),
          [r.id]: draft
        };
        console.error("Failed to comment on incident report", err);
      }
    },
    get_incident_reference_payload(r) {
      const payload = {};

      const incidentReferenceId = r.incident_reference_id || r.id;

      if (incidentReferenceId) payload.incident_reference_id = incidentReferenceId;

      return payload;
    },
    apply_incident_interaction_summary(report, summary) {
      report.total_likes = Number(summary.likes_count) || 0;
      report.total_comments = Number(summary.comments_count) || 0;
      report.comments = summary.comments;
      report.is_likes = Boolean(summary.liked_by_user);
      report.is_liked = report.is_likes;
    },
    async fetch_incident_interactions(r) {
      return axios.get(
        `${this.base_url}/report_incident_management/get_incident_report_interactions/`,
        {
          ...this.axios_config(),
          params: this.get_incident_reference_payload(r)
        }
      )
        .then(({ data }) => this.apply_incident_interaction_summary(r, data))
        .catch(err => console.warn("Failed to fetch incident interactions", r.id, err));
    },
    get_incident_url(r) {
      const base = `${window.location.origin}${this.$route?.path || window.location.pathname}`;
      return `${base}?incident_id=${encodeURIComponent(r.id)}`;
    },
    async copy_incident_link(r) {
      const link = this.get_incident_url(r);

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(link);
        } else {
          const textArea = document.createElement('textarea');
          textArea.value = link;
          textArea.setAttribute('readonly', '');
          textArea.className = 'clipboard-copy-buffer';
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
        }
      } catch (err) {
        console.warn('Unable to copy incident link', err);
      } finally {
        this.close_share_menu(r.id);
      }
    },
    clear_all_filters() {
      this.search_query = '';
      this.filter_status = 'All';
      this.filter_type = 'All';
      this.filter_location = 'All';
    },
    handle_incident_modal_shown() {
      if (this.editing_incident_report_id) return;

      this.select_default_entity_type(true);
    },
    handle_incident_modal_hidden() {
      this.clear_incident_modal();
    },
    clear_incident_modal() {
      this.editing_incident_report_id = null;
      this.selected_type_id = null;
      this.selected_form_id = null;
      this.form_schema = [];
      this.form_data = {};
      this.form_errors = {};
      this.files = [];
      this.feedback = { message: "", color: "" };
      this.is_submitting = false;
      this.is_loading = false;
    },
    hide_incident_modal() {
      const modal_element = document.getElementById("incidentModal");
      if (!modal_element) return;

      window.bootstrap.Modal.getOrCreateInstance(modal_element).hide();
    },
    show_incident_submit_success(reference_number, is_editing_report = false) {
      const action_label = is_editing_report ? "Updated" : "Submitted";
      const action_text = is_editing_report ? "updated" : "submitted";

      Swal.fire({
        icon: "success",
        title: `Report ${action_label}`,
        text: `Incident report ${action_text} successfully${reference_number ? ` (Ref: INC - ${reference_number})` : ""}.`,
        timer: 2500,
        showConfirmButton: false,
        position: "bottom-end",
        toast: true
      });
    },
    select_map_category(categoryName) {
      this.filter_type = this.filter_type === categoryName ? 'All' : categoryName;
    },
    reload_map() {
      if (this.show_map_view) {
        this.load_incident_markers_on_map();
      }
    },
    toggle_map() {
      this.show_map_view = !this.show_map_view;

      if (this.show_map_view) {
        this.load_google_maps_api()
          .then(() => {
            this.$nextTick(() => {
              if (this.show_map_view && !this.incident_map) {
                this.init_incident_map();
              }
            });
          })
          .catch(err => {
            console.error("Unable to load Google Maps", err);
          });
      }
    },
    init_incident_map() {
      const mapElement = document.getElementById("incident-map");

      if (!mapElement) return;

      this.incident_map = new window.google.maps.Map(mapElement, {
        center: { lat: -26.2041, lng: 28.0473 }, // Johannesburg
        zoom: 10,
        disableDefaultUI: false,
        fullscreenControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        zoomControl: true,
        gestureHandling: "cooperative",
        mapTypeId: "roadmap",
        scrollwheel: false,
      });

      this.load_incident_markers_on_map();
    },
    async load_incident_markers_on_map() {
      if (!this.incident_map) return;
      const marker_load_id = this.incident_marker_load_id + 1;
      this.incident_marker_load_id = marker_load_id;

      // clear old markers
      this.incident_markers.forEach(m => m.setMap(null));
      this.incident_markers = [];

      const bounds = new window.google.maps.LatLngBounds();

      const addMarker = (positionLiteral, entry) => {
        if (marker_load_id !== this.incident_marker_load_id) return;
        const categoryName = this.get_incident_category_name(entry);
        const categoryColor = this.get_incident_category_color(categoryName);
        const marker = new window.google.maps.Marker({
          map: this.incident_map,
          position: positionLiteral,
          title: `INC-${entry.id}`,
          icon: this.get_incident_marker_icon(categoryColor),
        });

        const infoWindow = new window.google.maps.InfoWindow({
          content: `
            <div class="incident-map-info-window">
              <b>INC-${entry.id}</b><br/>
              <small>${categoryName}</small><br/>
              ${entry.description || ""}<br/>
              <small>Status: ${this.get_current_status_label(entry)}</small>
            </div>
          `,
        });

        marker.addListener("click", () => {
          infoWindow.open(this.incident_map, marker);
          this.select_report(entry);
        });

        this.incident_markers.push(marker);
        bounds.extend(positionLiteral);
        this.incident_map.fitBounds(bounds, 80);
      };

      const processEntry = async entry => {
        if (!entry.location) return;

        try {
          const cachedLocation = this.location_geocode_cache[entry.location];

          let position = cachedLocation;

          if (!position) {
            const coords = await this.get_location_coordinates(entry.location);
            position = this.normalize_lat_lng(coords);
            this.location_geocode_cache[entry.location] = position;
          }

          if (position) {
            addMarker(position, entry);
          }

        } catch (err) {
          console.warn("Failed to map address", entry.location, err);
        }
      };

      await Promise.all(this.filtered_entries.map(processEntry));
    },
    get_incident_category_name(entry) {
      return entry?.entity_type?.entity_type_name|| entry?.incident_type?.entity_type_name || "Uncategorized";
    },
    normalize_incident_type_name(value) {
      return String(value || '').trim().toLowerCase();
    },
    get_incident_type_filter_value(type) {
      const id = type?.id;
      if (id !== undefined && id !== null && id !== '') return `id:${id}`;
      return `name:${this.normalize_incident_type_name(type?.entity_type_name || type?.name)}`;
    },
    get_incident_entry_type_id(entry) {
      return entry?.entity_type?.id ?? entry?.incident_type?.id ?? null;
    },
    matches_incident_type_filter(entry) {
      if (this.filter_type === 'All') return true;

      if (String(this.filter_type).startsWith('id:')) {
        const selected_id = String(this.filter_type).slice(3);
        const entry_id = this.get_incident_entry_type_id(entry);
        if (entry_id !== null && entry_id !== undefined) {
          return String(entry_id) === selected_id;
        }

        const selected_type = this.entity_types.find(type => String(type.id) === selected_id);
        return this.normalize_incident_type_name(this.get_incident_category_name(entry)) ===
          this.normalize_incident_type_name(selected_type?.entity_type_name || selected_type?.name);
      }

      const selected_name = String(this.filter_type).startsWith('name:')
        ? String(this.filter_type).slice(5)
        : this.filter_type;
      return this.normalize_incident_type_name(this.get_incident_category_name(entry)) ===
        this.normalize_incident_type_name(selected_name);
    },
    is_incident_category_selected(category_name) {
      if (this.filter_type === 'All') return false;
      if (!String(this.filter_type).startsWith('id:')) {
        const selected_name = String(this.filter_type).startsWith('name:')
          ? String(this.filter_type).slice(5)
          : this.filter_type;
        return this.normalize_incident_type_name(selected_name) ===
          this.normalize_incident_type_name(category_name);
      }

      const selected_id = String(this.filter_type).slice(3);
      const selected_type = this.entity_types.find(type => String(type.id) === selected_id);
      return this.normalize_incident_type_name(selected_type?.entity_type_name || selected_type?.name) ===
        this.normalize_incident_type_name(category_name);
    },
    get_incident_category_color(categoryName) {
      const palette = [
        "#0d6efd",
        "#dc3545",
        "#198754",
        "#fd7e14",
        "#6f42c1",
        "#20c997",
        "#d63384",
        "#0dcaf0",
        "#ffc107",
        "#6c757d",
      ];
      const normalizedName = String(categoryName || "Uncategorized");
      const entityTypeIndex = this.entity_types.findIndex(type => type.entity_type_name === normalizedName);

      if (entityTypeIndex !== -1) {
        return palette[entityTypeIndex % palette.length];
      }

      const hash = normalizedName.split("").reduce((total, char) => total + char.charCodeAt(0), 0);

      return palette[hash % palette.length];
    },
    get_incident_marker_icon(color) {
      const markerColor = /^#[0-9a-f]{6}$/i.test(color) ? color : "#0d6efd";
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="44" viewBox="0 0 36 44">
          <path fill="${markerColor}" d="M18 0C8.1 0 0 8.1 0 18c0 13.5 18 26 18 26s18-12.5 18-26C36 8.1 27.9 0 18 0z"/>
          <circle cx="18" cy="18" r="7" fill="#ffffff"/>
        </svg>
      `.trim();

      return ({
        url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
        scaledSize: new window.google.maps.Size(30, 36),
        anchor: new window.google.maps.Point(15, 36),
      });
    },
    get_incident_status_key(r) {
      const raw_status = [
        this.read_incident_value(r, ['incident_status', 'name']),
        this.read_incident_value(r, ['status', 'status']),
        Reflect.get(Object(r), 'status'),
      ].find(value => typeof value === 'string') || 'pending';
      const normalized_status = String(raw_status).trim().toLowerCase().replace(/[\s-]+/g, '_');
      const aliases = {
        pending_application: 'pending',
        pending_review: 'pending',
        approved: 'resolved',
      };
      return Reflect.get(aliases, normalized_status) || normalized_status;
    },
    get_step_index(r) {
      const sequenceNames = ['pending', 'assigned', 'in_progress', 'resolved'];
      const index = sequenceNames.indexOf(this.get_incident_status_key(r));
      return index !== -1 ? index : 0;
    },

    get_display_step_index(r) {
      const status_key = this.get_incident_status_key(r);
      const foundIndex = this.workflow_display_steps.findIndex(step => step.key === status_key);
      return foundIndex === -1 ? 0 : foundIndex;
    },

    get_step_class(r, index) {
      const currentIndex = this.get_display_step_index(r);
      if (index < currentIndex) return 'is-done';
      if (index === currentIndex) return 'is-current';
      return 'is-upcoming';
    },

    get_current_status_label(r) {
      const status_key = this.get_incident_status_key(r);
      const step = this.workflow_display_steps.find(item => item.key === status_key);
      return step?.label || 'Under Review';
    },

    get_current_dot_class(r) {
      const currentIndex = this.get_display_step_index(r);
      if (currentIndex === 0) return 'incident-dot-warning';
      if (currentIndex === 1) return 'incident-dot-muted';
      if (currentIndex === 2) return 'incident-dot-info';
      return 'incident-dot-success';
    },

    get_assigned_name(r) {
      const assigned_users = Reflect.get(Object(r), 'assigned_users');
      const assignment = Array.isArray(assigned_users) ? Reflect.get(assigned_users, 0) : null;
      const user = Reflect.get(Object(assignment), 'user');
      if (!user) return 'Unassigned';

      const generated_name = [Reflect.get(user, 'first_name'), Reflect.get(user, 'last_name')]
        .filter(Boolean)
        .join(' ');
      return [Reflect.get(user, 'full_name'), generated_name, Reflect.get(user, 'email')]
        .find(Boolean) || 'Unassigned';
    },
    get_incident_step_timestamp(r, step_key) {
      const fixed_timestamps = new Map([
        ['pending', Reflect.get(Object(r), 'date_created') ?? ''],
        ['assigned', this.read_incident_value(r, ['assigned_users', 0, 'created_at'], '')],
      ]);
      if (fixed_timestamps.has(step_key)) return fixed_timestamps.get(step_key);
      return step_key === this.get_incident_status_key(r) ? this.get_incident_status_timestamp(r) : '';
    },
    get_incident_status_timestamp(r) {
      return [
        this.read_incident_value(r, ['incident_status', 'updated_at']),
        Reflect.get(Object(r), 'status_updated_at'),
        Reflect.get(Object(r), 'updated_at'),
      ].find(Boolean) || '';
    },
    get_priority_label(r) {
      const candidate =
        r.priority?.name ||
        r.priority ||
        r.severity?.name ||
        r.severity ||
        r.urgency?.name ||
        r.urgency ||
        r.level ||
        r.priority_level;

      if (!candidate) return '';
      if (typeof candidate === 'string') return candidate;

      if (typeof candidate === 'number') {
        if (candidate >= 3) return 'High';
        if (candidate === 2) return 'Medium';
        return 'Low';
      }

      return '';
    },

    get_remaining_label(r) {
      return (
        r.time_remaining ||
        r.remaining_time ||
        r.remaining_label ||
        r.sla_remaining ||
        ''
      );
    },

    get_report_title(r) {
      const explicit = (r.title || r.subject || r.summary || '').toString().trim();
      if (explicit) return explicit;

      const desc = (r.description || '').toString();
      if (desc.includes('\n')) {
        const firstLine = desc.split('\n').map(s => s.trim()).find(Boolean);
        if (firstLine) return firstLine.length > 80 ? `${firstLine.slice(0, 80)}…` : firstLine;
      }

      return r.entity_type?.entity_type_name || `INC-${r.id}`;
    },

    get_report_body(r) {
      const desc = (r.description || '').toString().trim();
      if (!desc) return '';

      if (desc.includes('\n')) {
        const parts = desc.split('\n');
        const firstLine = (parts.shift() || '').trim();
        const rest = parts.join('\n').trim();
        if (firstLine && rest && firstLine.length <= 80) return rest;
      }

      return desc;
    },

    format_created_at(value) {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);

      const weekday = new Intl.DateTimeFormat('en-GB', { weekday: 'short' }).format(date);
      const day = new Intl.DateTimeFormat('en-GB', { day: '2-digit' }).format(date);
      const month = new Intl.DateTimeFormat('en-GB', { month: 'long' }).format(date);
      const year = new Intl.DateTimeFormat('en-GB', { year: 'numeric' }).format(date);
      const time = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false }).format(date);

      return `${weekday} ${day} ${month} ${year} · ${time}`;
    },

    format_time(value) {
      if (!value) return '';
      const asString = String(value);
      const match = asString.match(/(\d{2}:\d{2})/);
      if (match) return match[1];

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false }).format(date);
    },

    format_incident_tracking_time(value) {
      if (!value) return '';
      const date = new Date(value);

      if (Number.isNaN(date.getTime())) return this.format_time(value);

      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      }).format(date);
    },

    get_channel_badges(r) {
      const badges = [];
      const emailTime = r.email_time || r.last_email_time || r.email_sent_at;
      const inAppTime = r.in_app_time || r.last_in_app_time || r.in_app_sent_at || r.notification_sent_at;

      if (emailTime) {
        badges.push({
          key: 'email',
          label: `Email · ${this.format_time(emailTime)}`,
          icon: 'bi bi-envelope-fill',
          variant: 'incident-channel-email'
        });
      }

      if (inAppTime) {
        badges.push({
          key: 'in_app',
          label: `In-App · ${this.format_time(inAppTime)}`,
          icon: 'bi bi-bell-fill',
          variant: 'incident-channel-inapp'
        });
      }

      return badges;
    },

    initialize_map(questionId) {
      this.$nextTick(() => {
        const inputElement = document.getElementById(`search-input-${questionId}`);
        const mapElement = document.getElementById(`map-${questionId}`);

        if (!inputElement || !mapElement) {
          console.warn("Location elements not found in DOM yet.");
          return;
        }

        // 1. Initialize ONLY the autocomplete search on the input field
        const autocomplete = new window.google.maps.places.Autocomplete(inputElement);

        // 2. Listen for when the user actually selects an address
        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();

          // If they pressed enter without selecting a valid place, ignore it
          if (!place.geometry) return;

          // 3. UNHIDE the map container now that we need it
          mapElement.classList.remove('d-none');

          // 4. NOW build the map (since the div is visible, Google Maps won't crash)
          const map = new window.google.maps.Map(mapElement, {
            center: place.geometry.location,
            zoom: 16,
          });

          // 5. Drop the pin
          new window.google.maps.Marker({
            position: place.geometry.location,
            map: map,
            title: place.name
          });

          // 6. Update your Vue form_data so it submits to the backend
          Reflect.set(this.form_data, questionId, inputElement.value);
        });
      });
    },

    load_google_maps_api() {
      if (window.google && window.google.maps) {
        return Promise.resolve();
      }

      if (this.google_maps_load_promise) {
        return this.google_maps_load_promise;
      }

      this.google_maps_load_promise = new Promise((resolve, reject) => {
        const scriptId = "googleMapsScript";
        let script = document.getElementById(scriptId);

        if (!script) {
          script = document.createElement("script");
          script.id = scriptId;
          script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places&v=weekly`;
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);
        }

        const onLoad = () => {
          cleanup();
          resolve();
        };

        const onError = (error) => {
          cleanup();
          reject(error || new Error("Google Maps script failed to load"));
        };

        const cleanup = () => {
          script.removeEventListener("load", onLoad);
          script.removeEventListener("error", onError);
        };

        script.addEventListener("load", onLoad);
        script.addEventListener("error", onError);

        if (window.google && window.google.maps) {
          cleanup();
          resolve();
        }
      });

      return this.google_maps_load_promise;
    },

    load_google_map_event(questionId) {
      this.load_google_maps_api()
        .then(() => this.initialize_map(questionId))
        .catch(err => {
          console.error("Unable to load Google Maps for the location field", err);
        });
    },
    normalize_lat_lng(position) {
      if (!position) return null;

      // Supports both google.maps.LatLng and LatLngLiteral shapes
      if (typeof position.lat === 'function' && typeof position.lng === 'function') {
        return ({ lat: position.lat(), lng: position.lng() });
      }

      if (typeof position.lat === 'number' && typeof position.lng === 'number') {
        return ({ lat: position.lat, lng: position.lng });
      }

      const lat = Number(position.lat);
      const lng = Number(position.lng);
      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        return ({ lat, lng });
      }

      return null;
    },
    geocode_address(address) {
      return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address }, (results, status) => {
          if (status === "OK" && results[0]) {
            resolve(results[0].geometry.location);
          } else {
            const error = new Error(`Geocode failed: ${status}`);
            error.status = status;
            reject(error);
          }
        });
      });
    },

    find_place_location(address) {
      return new Promise((resolve, reject) => {
        const service = new window.google.maps.places.PlacesService(this.incident_map);
        service.findPlaceFromQuery(
          { query: address, fields: ["geometry"] },
          (results, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && results[0]?.geometry?.location) {
              resolve(results[0].geometry.location);
            } else {
              const error = new Error(`Places search failed: ${status}`);
              error.status = status;
              reject(error);
            }
          }
        );
      });
    },

    get_location_coordinates(address) {
      return this.geocode_address(address).catch(err => {
        // Fallback to Places search when Geocoder fails (rate limits / partial addresses)
        if (this.incident_map && window.google?.maps?.places) {
          return this.find_place_location(address);
        }
        throw err;
      });
    },
    axios_config: () => ({
      headers: {
        "Authorization": `Token ${get_token()}`
      }
    }),

    select_report(r) {
      this.selected = r
      this.detailTab = 'timeline'
    },

    status_count(s) {
      const count = s === 'All'
        ? this.logged_entries.length
        : this.logged_entries.filter(r => this.get_current_status_label(r) === s).length
      return count > 0 ? count : ''
    },
    async view_form_statuses() {
      const res = await axios.get(
        `${this.base_url}/report_incident_management/view_form_statuses/`,
        { ...this.axios_config() }
      );

      this.statuses = res.data.data || [];
    },

    handle_file_upload(event, questionId) {
      this.isDragging = false;

      const incomingFiles = event.dataTransfer?.files || event.target?.files || [];
      const files = Array.from(incomingFiles).map(file => this.normalize_basic_report_media(file));

      let currentFiles = Reflect.get(this.form_data, questionId);

      if (!Array.isArray(currentFiles)) {
        currentFiles = [];
        Reflect.set(this.form_data, questionId, currentFiles);
      }

      currentFiles.push(...files);
    },

    set_error(message) {
      this.feedback = { message };
    },
    is_required_incident_field(question = {}) {
      const question_type = question.question_type?.question_type;
      const question_text = String(question.question_text || "").toLowerCase();

      return question_type === "long_text" || (
        question_type === "short_text" && question_text.includes("location")
      );
    },
    clear_field_error(question_id) {
      if (!Reflect.get(this.form_errors, question_id)) return;

      const next_errors = { ...this.form_errors };
      Reflect.deleteProperty(next_errors, question_id);
      this.form_errors = next_errors;
    },
    validate_incident_required_fields() {
      const next_errors = {};

      this.form_schema.forEach((section) => {
        section.questions.forEach((question) => {
          if (!this.is_required_incident_field(question)) return;

          const value = this.form_data[question.section_question_id];
          const has_value = typeof value === "string"
            ? value.trim().length > 0
            : !!value;

          if (!has_value) {
            next_errors[question.section_question_id] = `${question.question_text} is required`;
          }
        });
      });

      this.form_errors = next_errors;
      return Object.keys(next_errors).length === 0;
    },

    async fetch_entity_types() {
      const config = this.axios_config();
      config.params = { project_id: this.project_id };
      const res = await axios.get(
        `${this.base_url}/report_incident_management/pull_entity_types/`, config
      );

      this.entity_types = this.sort_entity_types(res.data.data || []);
      this.select_default_entity_type();
    },
    sort_entity_types(types) {
      return [...types].sort((a, b) => {
        const aName = String(a.entity_type_name || "").trim().toLowerCase();
        const bName = String(b.entity_type_name || "").trim().toLowerCase();

        if (aName === "other") return -1;
        if (bName === "other") return 1;

        return aName.localeCompare(bName);
      });
    },
    select_default_entity_type(forceReload = false) {
      if (typeof window !== "undefined" && window.innerWidth < 768) return;

      const defaultType = this.entity_types[0];

      if (!defaultType) return;

      if (forceReload && this.selected_type_id === defaultType.id) {
        this.fetch_form_by_entity_type();
        return;
      }

      this.selected_type_id = defaultType.id;
    },

    // Step 1: Fetch Form ID by Entity Type
    async fetch_form_by_entity_type() {
      this.is_loading = true;
      this.form_schema = [];
      this.form_data = {};
      this.form_errors = {};
      this.feedback = { message: "", color: "" };

      const config = this.axios_config();
      config.params = { entity_type_id: this.selected_type_id }
      const res = await axios.get(
        `${this.base_url}/report_incident_management/pull_entity_form/`, config
      );

      // Parse stringified JSON if backend returns it
      const parsed = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
      const formId = parsed.data[0]?.id;

      if (!formId) {
        this.set_error("Form not found for selected type.");
        return;
      }

      this.selected_form_id = formId;
      await this.fetch_empty_form(formId);
    },

    // Step 2: Fetch Empty Form (Sections + Questions)
    async fetch_empty_form(formId) {

      const config = this.axios_config();
      config.params = { form_id: formId };
      try {
        const res = await axios.get(
          `${this.base_url}/report_incident_management/get_empty_form_by_id/`,
          config
        );

        const data = res.data.data;
        this.form_schema = data.sections || [];

        // Initialize reactive form_data
        this.form_schema.forEach(section => {
          section.questions.forEach(q => {
            Reflect.set(this.form_data, q.section_question_id, "");

            if (q.question_type.question_type === 'short_text' && q.question_text.toLowerCase().includes('location')) {
              this.load_google_map_event(q.section_question_id);
            }
          });
        });

      } catch (err) {
        console.error(err);
        this.set_error("Failed to load form questions.");
      }
    },

    remove_file(questionId, index) {
      // 1. Safely check if the property exists
      if (Reflect.has(this.form_data, questionId)) {
        const arr = Reflect.get(this.form_data, questionId);

        if (Array.isArray(arr)) {
          // 2. Get the specific file object to clean up memory
          const fileToRemove = Reflect.get(arr, index);

          if (fileToRemove) {
            const existing_file_id = Reflect.get(Object(fileToRemove), "id");
            if (
              this.editing_incident_report_id
              && !(fileToRemove instanceof File)
              && existing_file_id
              && !this.incident_report_files_to_delete.includes(existing_file_id)
            ) {
              this.incident_report_files_to_delete.push(existing_file_id);
            }

            // Revoke the Blob URL to prevent memory leaks
            if (fileToRemove.previewUrl) {
              URL.revokeObjectURL(fileToRemove.previewUrl);
            }

            // 3. Remove the file using Reflect.apply to ensure Proxy compatibility
            const spliceFn = Reflect.get(arr, 'splice');
            Reflect.apply(spliceFn, arr, [index, 1]);
          }
        }
      }
    },

    // Step 3: Submit Answers in Xverdict format
    async submit_incident() {
      if(this.incident_active === 'basic'){
        this.submit_basic_incident()
        return
      }

      if (!this.validate_incident_required_fields()) {
        return;
      }

      this.is_submitting = true;
      this.feedback = { message: "", color: "" };

      try {



        const form_data = new FormData()
        const answers = []

        form_data.append("entity_type_id", this.selected_type_id);
        form_data.append("project_id", this.project_id);
        form_data.append("form_ids", this.selected_form_id);
        form_data.append("current_section_index", 0);

        this.form_schema.forEach(section => {
          section.questions.forEach(q => {
            const value = this.form_data[q.section_question_id];
            const isFile = q.question_type.question_type === "file";

            if (isFile && Array.isArray(value) && value.length > 0) {
              value.forEach(file => {
                if (file instanceof File) {
                  form_data.append(`file_${q.section_question_id}`, file);
                }
              });

              // Save names in answers
              answers.push({
                section_question_id: q.section_question_id,
                answer_text: value.map(f => f.name).join(", ") // multiple file names
              });

            } else {
              answers.push({
                section_question_id: q.section_question_id,
                answer_text: value || ""
              });
            }
          });
        });

        form_data.append("answers", JSON.stringify(answers));

        const res = await axios.post(
          `${this.base_url}/report_incident_management/submit_form_answers/`,
          form_data,
          this.axios_config()
        );

        const reference_number = res.data.application_id || "N/A";

        this.select_default_entity_type();
        this.selected_form_id = null;
        this.form_schema = [];
        this.form_data = {};
        this.form_errors = {};
        this.files = [];

        await this.fetch_pending_entities(); // refresh the list
        this.hide_incident_modal();
        this.show_incident_submit_success(reference_number);

      } catch (err) {
        console.error(err);
        this.set_error(err.response?.data?.error || "Submission failed.");
      } finally {
        this.is_submitting = false;
      }
    },

    async fetch_pending_entities() {
      if (this.loading ) return;
      this.loading = true;
      const config = { ...this.axios_config(), params: { project_id: this.project_id } };

      try {
        const { data } = await axios.get(
          `${this.base_url}/report_incident_management/get_pending_entities/`,
          config
        );

        const rawEntries = Reflect.get(data.data, 'list_pending_entities') || [];

        this.logged_entries = rawEntries.map(entry => {
          // 1. Flatten all questions into one searchable array using Optional Chaining
          const allQuestions = entry.forms?.[0]?.sections?.flatMap(s => s.questions) || [];

          // 2. Helper for targeted extraction
          const findAnswer = (keywords) => {
            const normalizedKeywords = (Array.isArray(keywords) ? keywords : [keywords])
              .map(keyword => keyword.toLowerCase());

            const question = allQuestions.find(q => {
              const text = q.question_text?.toLowerCase() || "";
              return normalizedKeywords.some(keyword => text.includes(keyword));
            });

            return question?.answers?.[0]?.answer;
          };

          // 3. Specifically handle the "file" question type
          const fileQuestion = allQuestions.find(q => q.question_type === "file");
          const files = fileQuestion?.answers?.map((a, i) => ({
            name: a.file_name || `Attachment ${i + 1}`,
            url: a.presigned_url || a.answer || '#'
          })) || [];

          return {
            ...entry,
            location: findAnswer(["location", "incident location", "incident site", "address"]),
            description: findAnswer("description"),
            is_liked: Boolean(entry.is_liked ?? entry.is_likes),
            total_likes: entry.total_likes ?? entry.like_count ?? 0,
            total_comments: entry.total_comments ?? entry.comment_count ?? entry.comments?.length ?? 0,
            comments: entry.comments || [],
            files
          };
        });

        await Promise.allSettled(
          this.logged_entries.map(entry => this.fetch_incident_interactions(entry))
        );

      } catch (err) {
        console.error("Failed to fetch pending entities:", err);
      }finally{
        this.loading = false;
      }
    },

    trigger_file_input() {
      const element = this.$refs.fileInput;

      if (Array.isArray(element)) {
        element[0].click();
      } else {
        element.click();
      }
    },

    reset_modal() {
      this.clear_incident_modal();
      this.select_default_entity_type(true);
    }
  }
};
